module.exports = __webpack_public_path__ + "media/images/red_arrow-bfcd0c7c85889bc75f218f0bb2657806.png";